import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToHtmlPipe } from '../../utilities/to-htmlpipe/to-html.pipe';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-common-faq',
  templateUrl: './faq-on.component.html',
  imports: [CommonModule, ToHtmlPipe],
})
export class CommonFaqComponent implements OnInit {
  @Input() faqData: any;
  @Input() customClass: any;
  @Input() isWhiteBg: any;
  @Input() isInside: any;
  constructor() {}
  _faqData: any;
  activePanelIds: any = [];
  ngOnInit(): void {
    this._faqData = this.faqData;
  }
  ngOnChanges(): void {
    this._faqData = this.faqData;
  }
  onMouseOverConvert(index: any) {
    if (this.activePanelIds === index) {
      this.activePanelIds = -1;
    } else {
      this.activePanelIds = index;
    }
  }
}
